import { useState } from 'react'
import { isGE } from '../../Device'
import useEventCallback from '../../utils/useEventCallback'

const useTooltip = (options = {}) => {
  const [tooltip, setTooltip] = useState(false)

  const showTooltip = useEventCallback(() => setTooltip(true), [setTooltip])
  const hideTooltip = useEventCallback(() => setTooltip(false), [setTooltip])

  const shouldRegisterMouseListener = isGE() ? options?.ge : options?.pe

  const mouseListeners = shouldRegisterMouseListener
    ? {
        onMouseOver: showTooltip,
        onMouseOut: hideTooltip
      }
    : {}

  return { tooltip, setTooltip, mouseListeners }
}

export default useTooltip
